var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["common-card"] }, [
    _c("div", { staticClass: "common-card-block" }, [
      _c("h3", [_vm._v(_vm._s(_vm.data.index))]),
    ]),
    _c("strong", { staticClass: "text-font" }, [_vm._v(_vm._s(_vm.data.text))]),
    _vm.data.but
      ? _c(
          "div",
          {
            staticClass: "common-card-but",
            on: {
              click: function ($event) {
                return _vm.toLink(_vm.data.but)
              },
            },
          },
          [
            _c(
              "ButtonCommon",
              { attrs: { type: "infoMin", width: "100%", height: "32px" } },
              [
                _c("h6", { staticClass: "h6-mini" }, [
                  _vm._v(_vm._s(_vm.data.but.text)),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }